<template>
  <section id="dataregu">
    <h4 class="title is-5">{{ actionTitle }} Data Regu</h4>
    <div class="rows">
      <div class="row">
        <b-button
          class="button is-primary"
          tag="router-link"
          to="/biro/berandaregu"
          icon-left="arrow-left-bold"
          >Kembali</b-button
        >
      </div>
      <div class="rows">
        <div class="box">
          <section>
            <b-field
              horizontal
              label="Nama Regu"
              :type="form.nama_regu.type"
              :message="form.nama_regu.message"
            >
              <b-input
                name="nama_regu"
                @input="clearError(form.nama_regu)"
                placeholder="Nama Regu"
                v-model="form.nama_regu.value"
                expanded
              ></b-input>
            </b-field>

            <b-field horizontal label="Pilih Dosen Pembina" 
              :type="form.nama_personil.type"
              :message="form.nama_personil.message">
              <b-table
                :data="dosen_pembina"
                :loading="isLoading"
                :mobile-cards="true"
                bordered
                striped
                narrowed
                hoverable
                ref="table"
                paginated
                per-page="5"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
                :checked-rows.sync="checkedPembina"
                :is-row-checkable="(row) => checkedPembina.length !== 1"  
                checkable
                @check="clearError(form.nama_personil)"
                checkbox-position="left"
              >
                <button class="button field is-danger" @click="checkedPembina = []"
                  :disabled="!checkedPembina.length">
                  <b-icon icon="close"></b-icon>
                  <span>Batalkan Pilihan</span>
                </button>

                <b-table-column
                  field="nama_personil"
                  label="Nama Personil"
                  sortable
                  :searchable="true" 
                  v-slot="props"
                >
                  {{ props.row.nama_personil }}
                </b-table-column>
                <b-table-column
                  field="nama_biro"
                  label="Asal Biro"
                  sortable
                  v-slot="props"
                >
                  {{ props.row.nama_biro }}
                </b-table-column>
                <b-table-column
                  field="jabatan"
                  label="Jabatan"
                  sortable
                  v-slot="props"
                >
                  {{ props.row.jabatan }}
                </b-table-column>

              </b-table>
            </b-field>
            <!------------------ INI GURU INTI ---------------------->
            <b-field horizontal label="Pilih Guru Inti"
            :type="form.nama_guru_inti.type"
              :message="form.nama_guru_inti.message">
              <b-table
                :data="gurus"
                :loading="isLoading"
                :mobile-cards="true"
                bordered
                striped
                narrowed
                hoverable
                ref="table"
                paginated
                per-page="5"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
                :checked-rows.sync="checkedInti"
                :is-row-checkable="(row) => checkedInti.length !== 1"
                checkable
                checkbox-position="left"
                @check="clearError(form.nama_guru_inti), (row) => hapusRow(row)"
              > 
               <button class="button field is-danger" @click="checkedInti = []"
                  :disabled="!checkedInti.length">
                  <b-icon icon="close"></b-icon>
                  <span>Batalkan Pilihan</span>
                </button>
                <b-table-column
                  field="nama_guru"
                  label="Nama Guru"
                  sortable
                  :searchable="true" 
                  v-slot="props"
                >
                  {{ props.row.nama_guru }}
                </b-table-column>
                <b-table-column
                  field="nama_sekolah"
                  label="Asal Sekolah"
                  sortable
                  v-slot="props"
                >
                  {{ props.row.nama_sekolah }}
                </b-table-column>
                <b-table-column
                  field="mata_pelajaran"
                  label="Mata Pelajaran"
                  sortable
                  v-slot="props"
                >
                  {{ props.row.mata_pelajaran }}
                </b-table-column>
              </b-table>
            </b-field>
             <!------------------ INI GURU SASARAN ---------------------->
            <!-- <p>Guru Inti hanya 1</p> -->
            <b-field horizontal label="Pilih Guru Sasaran"
            :type="form.nama_guru_sasaran.type"
            :message="form.nama_guru_sasaran.message">
              <b-table
                :data="gurus"
                :loading="isLoading"
                :mobile-cards="true"
                bordered
                striped
                narrowed
                hoverable
                ref="table"
                paginated
                per-page="5"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
                :checked-rows.sync="checkedSasaran"
                :is-row-checkable="(row) => checkedInti.length !==0 && row.id_guru !== checkedInti[0].id_guru"
                checkable
                @check="clearError(form.nama_guru_sasaran)"
                checkbox-position="left"
              >
                <b-table-column
                  field="nama_guru"
                  label="Nama Guru"
                  sortable
                  :searchable="true" 
                  v-slot="props"
                >
                  {{ props.row.nama_guru }}
                </b-table-column>
                <b-table-column
                  field="nama_sekolah"
                  label="Asal Sekolah"
                  sortable
                  v-slot="props"
                >
                  {{ props.row.nama_sekolah }}
                </b-table-column>
                <b-table-column
                  field="mata_pelajaran"
                  label="Mata Pelajaran"
                  sortable
                  v-slot="props"
                >
                  {{ props.row.mata_pelajaran }}
                </b-table-column>
              </b-table>
            </b-field>

            <b-field
              horizontal
              label="Jumlah Guru Sasaran"
              :type="form.jml_anggota_regu.type"
              :message="form.jml_anggota_regu.message"
            >
              <b-input
                disabled
                v-model="checkedSasaran.length"
                @input="clearError(form.jml_anggota_regu)"
                min="0"
                max="11"
              ></b-input>
            </b-field>

            <!------------------ INI SISWA---------------------->
            <b-field horizontal label="Pilih Siswa"
              :type="form.nama_siswa.type"
              :message="form.nama_siswa.message">
              <b-table
                :data="siswas"
                :loading="isLoading"
                :mobile-cards="true"
                bordered
                striped
                narrowed
                hoverable
                ref="table"
                paginated
                per-page="5"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
                :checked-rows.sync="checkedSiswa"
                checkable
                checkbox-position="left"
              >
                <b-table-column
                  field="nama_siswa"
                  label="Nama Siswa"
                  sortable
                  :searchable="true" 
                  v-slot="props"
                >
                  {{ props.row.nama_siswa }}
                </b-table-column>
                <b-table-column
                  field="nama_sekolah"
                  label="Asal Sekolah"
                  sortable
                  v-slot="props"
                >
                  {{ props.row.nama_sekolah }}
                </b-table-column>
              </b-table>
            </b-field>

            <b-field
              horizontal
              label="Jumlah Siswa"
              :type="form.jml_siswa.type"
              :message="form.jml_siswa.message"
            >
              <b-input
                disabled
                v-model="checkedSiswa.length"
                @input="clearError(form.jml_siswa)"
                min="0"
                max="11"
              ></b-input>
            </b-field>
            <b-field horizontal
              ><!-- Label left empty for spacing -->
              <p class="control">
                <button class="button is-primary" @click="confirm()">
                  Simpan
                </button>
              </p>
            </b-field>
          </section>
        </div>
      </div>
    </div>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    >
    </b-loading>
  </section>
</template>

<script>
export default {
  data() {
    return {
      guru: {
        nuptk: "",
        nama_guru: "",
        jenis_kelamin: "",
        tgl_lahir: "",
        no_handphone: "",
        email: "",
        mata_pelajaran: "",
        jenis_guru: "",
        nama_sekolah: "",
        nama_regu: "",
      },
      siswa:{
        nama_siswa:"",
        email:"",
        jenis_kelamin:"",
        tgl_lahir:"",
        no_handphone:"",
        kelas:"",
        nama_sekolah:"",

      },
      isLoading: true,
      actionTitle: "",
      editID: 0,
      dataRegu: new FormData(),
      editDataRegu: {},
      
      form: {
        nama_regu: {
          value: "",
          type: "",
          message: "",
        },
        nama_personil: {
          value: "",
          type: "",
          message: "",
        },
    
        nama_guru_inti: {
          value: "",
          type: "",
          message: "",
        },

        nama_guru_sasaran: {
          value: "",
          type: "",
          message: "",
        },
        jml_anggota_regu: {
          value: 0,
          type: "",
          message: "",
        },
        nama_siswa: {
          value: "",
          type: "",
          message: "",
        },
        jml_siswa: {
          value: 0,
          type: "",
          message: "",
        },
        deleted_at: {
          value: "",
          type: "",
          message: "",
        },
      },
      snackbarMessage: "",
      id_regu: '',
      personil_biro: [],
      dosen_pembina: [],
      gurus: [],
      siswas:[],
      checkedPembina: [],
      checkedSiswa:[],

      guru_inti: [],
      guru_sasaran: [],

      checkedInti: [],
      checkedSasaran: [],

      intiLama: [],
      sasaranLama: [],
      siswaLama: [],

      detailId:'',
      config:{}
    };
  },
  methods: {
    hapusRow(row){
      console.log(row[0].id_guru)
      if(this.checkedSasaran.length !== 0){
        for(var i=0; i<this.checkedSasaran.length; i++){
          if(this.checkedSasaran[i].id_guru === row[0].id_guru){
            this.checkedSasaran.splice(i, 1)
          }
        }
      }
    },

    getPersonilBiro() {
      var uri = this.$apiUrl + 'personil_biro/biro/' + this.detailId
      this.$http.get(uri, this.config).then((response) => {
       this.personil_biro = response.data.value;//get personil biro terlebih dahulu
        for (var i = 0; i < this.personil_biro.length; i++) {
          if (this.personil_biro[i].jabatan == "Dosen Pembina") { //dicari yg jabatannya dosen pembina
            this.dosen_pembina.push(this.personil_biro[i]); //lalu dr jabatan di personil biro dipush ke dosen pembina
          }
        }
      });
    },
    getGuruTanpaRegu() { //belum masuk regu
      var uri = this.$apiUrl + 'guru/regu/' + this.detailId
      this.$http.get(uri, this.config).then((response) => {
        this.gurus = response.data.value;
      });
    },
    getSiswaTanpaRegu() { //belum masuk regu
      var uri = this.$apiUrl + 'siswa/regu/' + this.detailId
      this.$http.get(uri, this.config).then((response) => {
        this.siswas = response.data.value;
      });
    },
    getGuru(editID) { //all guru
      var uri = this.$apiUrl + 'guru/biro/' + this.detailId
      this.$http.get(uri, this.config).then((response) => {
        var tempGuru = response.data.value //get semua guru
        // this.gurus = response.data.value;
        console.log(editID)//tampil berdasarkan id regu

        for(var i=0;i<tempGuru.length;i++){
          if(String(tempGuru[i].id_regu) === editID || tempGuru[i].id_regu === null){
            this.gurus.push(tempGuru[i])
          }
        }

        for(var i=0; i<this.gurus.length; i++){
          if(String(this.gurus[i].id_regu) === editID && this.gurus[i].jenis_guru == "Guru Sasaran"){ 
            this.checkedSasaran.push(this.gurus[i])
          }else if(String(this.gurus[i].id_regu) === editID && this.gurus[i].jenis_guru == "Guru Inti"){
            this.checkedInti.push(this.gurus[i])
          }
        }
        this.intiLama = this.checkedInti
        this.sasaranLama = this.checkedSasaran

        console.log(this.intiLama)
        console.log(this.sasaranLama)
      });
    },
    getData(editID) {
      var uri = this.$apiUrl + "regu/" + editID;

      this.$http.get(uri, this.config).then((response) => {
        this.editDataRegu = response.data.value;
        this.formEdit(this.editDataRegu);
      });
    },
    getSiswa(editID) { //all guru
      var uri = this.$apiUrl + 'siswa/biro/' + this.detailId
      this.$http.get(uri, this.config).then((response) => {
        var tempSiswa = response.data.value //get semua guru
        // this.gurus = response.data.value;
        console.log(editID)//tampil berdasarkan id regu
        // console.log(tempSiswa)

        for(var i=0;i<tempSiswa.length;i++){
          if(String(tempSiswa[i].id_regu) === editID || tempSiswa[i].id_regu === null){
            this.siswas.push(tempSiswa[i])
          }
        }

        // for(var i=0; i<this.siswas.length; i++){
        //   if(String(this.siswas[i].id_regu) === editID){ 
        //     this.checkedSiswaSasaran.push(this.siswas[i])
        //   }else if(String(this.gurus[i].id_regu) === editID){
        //     this.checkedSiswaInti.push(this.siswas[i])
        //   }
        // }

        console.log(this.siswas)

        for(var i=0; i<this.siswas.length; i++){
          if(String(this.siswas[i].id_regu) === editID){ 
            this.checkedSiswa.push(this.siswas[i])
          }
        }
        this.siswaLama = this.checkedSiswa
        // this.siswaSasaranLama = this.checkedSiswaSasaran

        // console.log(this.siswaIntiLama)
        // console.log(this.siswaSasaranLama)
      });
    },
   
    formEdit(dataRegu) {
      this.form.nama_regu.value = dataRegu.nama_regu;
      this.form.nama_personil.value = dataRegu.id_pembina;
      this.form.nama_guru_inti.value = dataRegu.id_ketua_regu;
      // this.form.nama_siswa.value = dataRegu.id_siswa;
       this.form.jml_siswa.value = dataRegu.jml_siswa;
      this.form.jml_anggota_regu.value = dataRegu.jml_anggota_regu;

      for(var i=0; this.personil_biro.length; i++){
          if(this.personil_biro[i].id_personil === dataRegu.id_pembina){
            this.checkedPembina.push(this.personil_biro[i])
            break
          }
        }
    },
    clearError(form) {
      console.log(form);
      form.type = "";
      form.message = "";
    },
    checkData() {
      let count = 0;
      //let regexTelp = new RegExp(/^\d+$/);
      if (this.form.nama_regu.value === "") {
        // this.snackbar("Gagal Ditambahkan", "is-danger");
        this.form.nama_regu.type = "is-danger";
        this.form.nama_regu.message = "Nama Regu harus di isi";
        count++;
      }
      if (this.checkedPembina.length === 0) {
        this.form.nama_personil.type = "is-danger";
        this.form.nama_personil.message = "Pembina harus diisi";
        count++;
      }
      
      if (this.checkedInti.length === 0) {
        this.form.nama_guru_inti.type = "is-danger";
        this.form.nama_guru_inti.message = "Guru Inti harus diisi";
        count++;
      }

      if (this.checkedSasaran.length === 0) {
        this.form.nama_guru_sasaran.type = "is-danger";
        this.form.nama_guru_sasaran.message = "Guru Sasaran harus diisi";
        count++;
      }

      // if (this.form.siswa.value === "") {
      //   this.form.siswa.type = "is-danger";
      //   this.form.siswa.message = "Guru Inti harus diisi";
      //   count++;
      // }

      if (count > 0) return false;
    },
    updateSiswa(siswa){
      let dataSiswa = new FormData()
      dataSiswa.append("nama_siswa", siswa.nama_siswa)
      dataSiswa.append("email", siswa.email)
      dataSiswa.append("jenis_kelamin", siswa.jenis_kelamin)
      dataSiswa.append("tgl_lahir", siswa.tgl_lahir)
      dataSiswa.append("no_handphone", siswa.no_handphone)
      dataSiswa.append("kelas", siswa.kelas)
      dataSiswa.append("id_sekolah", siswa.id_sekolah)
      dataSiswa.append("id_regu", this.id_regu)

      console.log(siswa)
      console.log(this.id_regu)

       var uri = this.$apiUrl + "siswa/" + siswa.id_siswa;
        this.$http
          .post(uri, dataSiswa, this.config)
          .then((response) => {
            console.log(response.data.value)
          })
          .catch((error) => {
          });
    },

    updateSiswaLama(siswa){
      let dataSiswa = new FormData()
      dataSiswa.append("nama_siswa", siswa.nama_siswa)
      dataSiswa.append("email", siswa.email)
      dataSiswa.append("jenis_kelamin", siswa.jenis_kelamin)
      dataSiswa.append("tgl_lahir", siswa.tgl_lahir)
      dataSiswa.append("no_handphone", siswa.no_handphone)
      dataSiswa.append("kelas", siswa.kelas)
      dataSiswa.append("id_sekolah", siswa.id_sekolah)
      dataSiswa.append("id_regu", "")

      // console.log(siswa)
      // console.log(this.id_regu)

       var uri = this.$apiUrl + "siswa/" + siswa.id_siswa;
        this.$http
          .post(uri, dataSiswa, this.config)
          .then((response) => {
            console.log(response.data.value)
          })
          .catch((error) => {
          });
    },

    // GURU
    updateGuru(guru, jenis){
      let dataGuru = new FormData()
      dataGuru.append("nuptk", guru.nuptk)
      dataGuru.append("nama_guru", guru.nama_guru)
      dataGuru.append("jenis_kelamin", guru.jenis_kelamin)
      dataGuru.append("tgl_lahir", guru.tgl_lahir)
      dataGuru.append("no_handphone", guru.no_handphone)
      dataGuru.append("email", guru.email)
      dataGuru.append("mata_pelajaran", guru.mata_pelajaran)
      dataGuru.append("jenis_guru", jenis)
      dataGuru.append("id_sekolah", guru.id_sekolah)
      dataGuru.append("id_regu", this.id_regu)

      console.log(guru)

       var uri = this.$apiUrl + "guru/" + guru.id_guru;
        this.$http
          .post(uri, dataGuru, this.config)
          .then((response) => {
            console.log(response.data.value)
          })
          .catch((error) => {
            console.log(error)
          });
    },

    updateGuruLama(guru){
      let dataGuru = new FormData()
      dataGuru.append("nuptk", guru.nuptk)
      dataGuru.append("nama_guru", guru.nama_guru)
      dataGuru.append("jenis_kelamin", guru.jenis_kelamin)
      dataGuru.append("tgl_lahir", guru.tgl_lahir)
      dataGuru.append("no_handphone", guru.no_handphone)
      dataGuru.append("email", guru.email)
      dataGuru.append("mata_pelajaran", guru.mata_pelajaran)
      dataGuru.append("id_sekolah", guru.id_sekolah)
      dataGuru.append("id_regu", "")
      dataGuru.append("jenis_guru", "")

       var uri = this.$apiUrl + "guru/" + guru.id_guru;
        this.$http
          .post(uri, dataGuru, this.config)
          .then((response) => {
            console.log(response.data.value)
          })
          .catch((error) => {
            console.log(error)
          });
    },

    tambahData() {
      this.isLoading = true;

      //console.log(this.form)
      //console.log(this.checkedInti)

      if (this.checkData() === false) {
        this.isLoading = false
        this.snackbar("Gagal...Silahkan input lagi", "is-danger");
      } else {
        this.form.nama_personil.value = this.checkedPembina[0].id_personil
        this.form.nama_guru_inti.value = this.checkedInti[0].id_guru
        this.form.jml_anggota_regu.value = this.checkedSasaran.length
        this.form.jml_siswa.value = this.checkedSiswa.length
        
        this.dataRegu.append("nama_regu", this.form.nama_regu.value);
        this.dataRegu.append("id_pembina", this.form.nama_personil.value);
        this.dataRegu.append("id_ketua_regu", this.form.nama_guru_inti.value);
        this.dataRegu.append("jml_anggota_regu", this.form.jml_anggota_regu.value);
        this.dataRegu.append("jml_siswa", this.form.jml_siswa.value);

        var uri = this.$apiUrl + "regu";
        this.$http
          .post(uri, this.dataRegu, this.config)
          .then((response) => {
            this.id_regu = response.data.value.id_regu

            console.log(this.id_regu)
            this.updateGuru(this.checkedInti[0], "Guru Inti")
            
            for(var i=0; i<this.checkedSasaran.length; i++){
              this.updateGuru(this.checkedSasaran[i], "Guru Sasaran")
            }

             for(var i=0; i<this.checkedSiswa.length; i++){
              this.updateSiswa(this.checkedSiswa[i])
            }

            this.isLoading = false;
            this.$router.push({ name: "BerandaRegu" });
            this.snackbarMessage = response.data.message;
            this.snackbar(
              "Berhasil Ditambahkan...",
              "is-success"
            );
          })
          .catch((error) => {
            this.errors = error;
            console.log(this.errors);
            this.isLoading = false;
            if (this.errors.message == "Request failed status code 400") {
              this.snackbar("Gagal Ditambahkan", "is-danger");
            } else {
              this.snackbar("Silahkan coba lagi", "is-danger");
            }
          });
      }
    },

    editData(editID) {
      this.isLoading = true;

      if (this.checkData() == false) {
        this.isLoading = false
        this.snackbar("Gagal Diedit", "is-danger");
      } else {
        this.form.nama_personil.value = this.checkedPembina[0].id_personil
        this.form.nama_guru_inti.value = this.checkedInti[0].id_guru
        // this.form.nama_siswa.value = this.checkedSiswa[0].id_siswa
        this.form.jml_anggota_regu.value = this.checkedSasaran.length
        this.form.jml_siswa.value = this.checkedSiswa.length
        
        this.editDataRegu.nama_regu = this.form.nama_regu.value;
        this.editDataRegu.id_pembina = this.form.nama_personil.value;
        this.editDataRegu.id_ketua_regu = this.form.nama_guru_inti.value;
        this.editDataRegu.jml_anggota_regu = this.form.jml_anggota_regu.value;
        this.editDataRegu.jml_siswa = this.form.jml_siswa.value;

        var data = {
          regu: JSON.stringify(this.editDataRegu),
          inti_lama: JSON.stringify(this.intiLama[0]),
          inti_baru: JSON.stringify(this.checkedInti[0]),
          guru_lama: JSON.stringify(this.sasaranLama),
          guru_baru: JSON.stringify(this.checkedSasaran),
          siswa_lama: JSON.stringify(this.siswaLama),
          siswa_baru: JSON.stringify(this.checkedSiswa)
        }

        var uri = this.$apiUrl + "regu/" + editID;
        this.$http
          .post(uri, data, this.config)
          .then((response) => {
            this.id_regu = response.data.value.id_regu

            //update guru inti dan sasaran lama
            // this.updateGuruLama(this.intiLama[0])
            // for(var i=0; i<this.sasaranLama.length; i++){
            //   this.updateGuruLama(this.sasaranLama[i])  // pas ini belum seleesai, belum dateng semua response nya
            // }
            
            //update guru inti dan sasaran baru
            // this.updateGuru(this.checkedInti[0], "Guru Inti")
            // for(var i=0; i<this.checkedSasaran.length; i++){
            //   this.updateGuru(this.checkedSasaran[i], "Guru Sasaran") // ini udah jalan duluan, response ee malah datang duluan
            // }

            //update siswa lama
            // for(var i=0; i<this.siswaLama.length; i++){
            //   this.updateSiswaLama(this.siswaLama[i])
            // }

            // //update siswa baru
            // for(var i=0; i<this.checkedSiswa.length; i++){
            //   this.updateSiswa(this.checkedSiswa[i])
            // }
            this.isLoading = false;
            this.$router.push({ name: "BerandaRegu" });
            this.snackbarMessage = response.data.message;
            this.snackbar(
              "Berhasil Diedit",
              "is-success"
            );
          })
          .catch((error) => {
            this.errors = error;
            console.log(this.errors);
            if (this.errors.message == "Request failed status code 400") {
              this.snackbar("Gagal Diedit", "is-danger");
            } else {
              this.snackbar("Silahkan coba lagi", "is-danger");
            }
            this.isLoading = false;
          });
      }
    },
    confirm() {
      this.editID == 0 ? this.tambahData() : this.editData(this.editID);
    },
    snackbar(snackbarMessage, type) {
      this.$buefy.toast.open({
        duration: 5000, //3 detik
        message: snackbarMessage,
        //type: type,
        position: "is-top",
        actionText: "OK",
        queue: false,
        type: type,
      });
    },
  },
  mounted() {
    if(this.$session.exists()){
      this.config = {
        headers: {
          'Authorization': 'Bearer ' + this.$session.get('token')
        }
      }
    }

    this.activeBiro = this.$session.get('biro')
    if(this.activeBiro)
    {
    this.detailId = this.activeBiro.id_biro
    this.getPersonilBiro()
    }
    if (this.$route.params.id) {
      this.editID = this.$route.params.id;
      this.actionTitle = "Ubah";
      this.getGuru(this.editID)
      this.getData(this.editID)
      this.getSiswa(this.editID);
    } else {
      this.actionTitle = "Tambah";
      this.getGuruTanpaRegu()
      this.getSiswaTanpaRegu()
    }
    this.isLoading = false;
  },
};
</script>